export function MailIcon() {
  return (
    <svg aria-hidden className="size-3.5" fill="none" viewBox="0 0 16 16">
      <path
        d="M2.5 4.25h11v7.5h-11v-7.5Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
      <path
        d="m3.25 5 4.75 3.55L12.75 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  )
}

export function LockIcon() {
  return (
    <svg aria-hidden className="size-3.5" fill="none" viewBox="0 0 16 16">
      <path
        d="M4.25 7h7.5v6h-7.5V7Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
      <path
        d="M5.75 7V5.75a2.25 2.25 0 0 1 4.5 0V7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.3"
      />
    </svg>
  )
}

export function KeyIcon() {
  return (
    <svg aria-hidden className="size-3.5" fill="none" viewBox="0 0 16 16">
      <path
        d="M6.6 8.3a3 3 0 1 1 1.1 1.1L6 11.1H4.6v1.4H3.2v1.3H1.8v-2.2l4.8-3.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
      <path d="M11.35 4.65h.01" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </svg>
  )
}
